// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__LyFKL","productName":"Table_productName__32OhY"};